import React, { useEffect, useRef } from 'react';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

//   Clustering behavior:
//   - Low zoom: nearby pins collapse into cluster bubbles (grouped by region)
//   - High zoom: individual team avatar pins visible
//   - When Bob search is active (searchActive prop): clustering disabled,
//     all filtered pins show individually

function MapClusterer({ google, map, markers, searchActive, pinSize }) {
    const clustererRef = useRef(null);

    useEffect(() => {
        if (!google || !map || !markers.length) return;

        // If search is active, skip clustering — React markers handle display.
        // Native markers stay at map: null (hidden) — don't show them individually.
        if (searchActive) {
            if (clustererRef.current) {
                clustererRef.current.clearMarkers();
                clustererRef.current.setMap(null);
                clustererRef.current = null;
            }
            return;
        }

        // Create clusterer with styled cluster icons
        const renderer = {
            render({ count, position }) {
                return new google.maps.Marker({
                    position,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        fillColor: '#fc9a09',
                        fillOpacity: 0.85,
                        strokeColor: '#ffffff',
                        strokeWeight: 2,
                        scale: 28,
                    },
                    label: {
                        text: String(count),
                        color: '#ffffff',
                        fontSize: '14px',
                        fontWeight: 'bold',
                    },
                    zIndex: 1000,
                });
            },
        };

        clustererRef.current = new MarkerClusterer({
            map,
            markers,
            renderer,
            // Larger grid + lower maxZoom = bigger clusters (10+ pins per bubble)
            // gridSize 150 covers more area per cell, maxZoom 11 keeps clustering
            // active until you zoom in quite close
            options: {
                maxZoom: 11,
                gridSize: 150,
            },
        });

        return () => {
            if (clustererRef.current) {
                clustererRef.current.clearMarkers();
                clustererRef.current.setMap(null);
                clustererRef.current = null;
            }
        };
    }, [google, map, markers, searchActive]);

    return null;
}

export default MapClusterer;
